import { gql } from '@apollo/client';

export const PROMO_CODE_FRAGMENT = gql`
  fragment PromoCodeFields on PromoCodeEntity {
    active
    active_from
    active_to
    amount
    counters {
      used
    }
    applicable_params
    client_scope {
      ... on ScopedClient {
        avatar_url
        id
        phone
      }
      ... on ScopedGroup {
        id
        title
      }
    }
    code
    created_at
    id
    is_tracked
    scopes
    value {
      currency {
        alias
        letter
      }
      type
      value
    }
  }
`;

export const PROMO_CAMPAIGN_FRAGMENT = gql`
  fragment PromoCampaignFields on PromoCampaign {
    id
    title
    description
    value {
      currency {
        alias
        letter
      }
      type
      value
    }
    applicable_params
    client_scope {
      ... on ScopedClient {
        avatar_url
        id
        phone
      }
      ... on ScopedGroup {
        id
        title
      }
    }
    scopes
    generation_settings {
      length
      prefix
      type
    }
    counters {
      total
      used
    }
    active
    active_from
    active_to
    is_tracked
    created_at
    updated_at
  }
`;

export const GET_PROMO_CODE = gql`
  ${PROMO_CODE_FRAGMENT}
  query PromoCodeV2($promoCodeId: Int!) {
    promoCode(id: $promoCodeId) {
      ...PromoCodeFields
    }
  }
`;
export const GET_PROMO_CAMPAIGN = gql`
  ${PROMO_CAMPAIGN_FRAGMENT}
  query PromoCampaignV2($promoCampaignId: String!) {
    promoCampaign(id: $promoCampaignId) {
      ...PromoCampaignFields
    }
  }
`;

export const GET_PROMO_CODES = gql`
  ${PROMO_CODE_FRAGMENT}
  query PromoCodesListV2(
    $filter: PromoListFilterInput
    $page: Int
    $count: Int
  ) {
    promoCodesList(filter: $filter, page: $page, count: $count) {
      items {
        ...PromoCodeFields
      }
      paginatorInfo {
        count
        currentPage
        lastPage
        total
      }
    }
  }
`;
export const GET_PROMO_CAMPAIGNS = gql`
  ${PROMO_CAMPAIGN_FRAGMENT}
  query promoCampaignListV2(
    $filter: PromoListFilterInput
    $page: Int
    $count: Int
  ) {
    promoCampaignList(filter: $filter, page: $page, count: $count) {
      items {
        ...PromoCampaignFields
      }
      paginatorInfo {
        count
        currentPage
        lastPage
        total
      }
    }
  }
`;

export const CREATE_PROMO_CAMPAIGN = gql`
  ${PROMO_CAMPAIGN_FRAGMENT}
  mutation CreatePromoCampaignV2($input: PromoCampaignInput!) {
    createPromoCampaign(input: $input) {
      ...PromoCampaignFields
    }
  }
`;

export const CREATE_PROMO_CODE = gql`
  ${PROMO_CODE_FRAGMENT}
  mutation CreatePromoCodeV2($input: PromoCodeEntityInput!) {
    createPromoCode(input: $input) {
      ...PromoCodeFields
    }
  }
`;

export const UPDATE_PROMO_CODE = gql`
  ${PROMO_CODE_FRAGMENT}
  mutation UpdatePromoCodeV2($id: Int!, $input: UpdatePromoCodeEntityInput!) {
    updatePromoCode(id: $id, input: $input) {
      ...PromoCodeFields
    }
  }
`;

export const UPDATE_PROMO_CAMPAIGN = gql`
  ${PROMO_CAMPAIGN_FRAGMENT}
  mutation UpdatePromoCampaignV2(
    $id: String!
    $input: UpdatePromoCampaignInput!
  ) {
    updatePromoCampaign(id: $id, input: $input) {
      ...PromoCampaignFields
    }
  }
`;

export const DELETE_PROMO_CODE = gql`
  mutation DeletePromoCodeV2($id: Int!) {
    deletePromoCode(id: $id) {
      id
      code
    }
  }
`;

export const DELETE_PROMO_CAMPAIGN = gql`
  mutation DeletePromoCampaignV2($id: String!) {
    deletePromoCampaign(id: $id) {
      id
    }
  }
`;

export const PROMO_CAMPAIGN_TO_CSV = gql`
  query promoCampaignCodesToCsvV2($promoCampaignCodesToCsvId: String!) {
    promoCampaignCodesToCsv(id: $promoCampaignCodesToCsvId)
  }
`;

export const GENERATE_PROMO_CODES = gql`
  mutation GeneratePromoCodesV2($id: String!, $amount: Int!) {
    generatePromoCodes(promo_campaign_id: $id, amount: $amount) {
      id
    }
  }
`;
